<!-- eslint-disable prettier/prettier -->
<template>
  <div class="sidebar-validasi">
    <div style="padding:10px; display:flex; border-bottom:1px solid #ddd;">
      <Input
        type="text"
        :value.sync="keywordTxt"
        placeholder="Cari .."
        width="320px"
        right-icon="search"
      />
    </div>
    <div>
      <List
        dbref="DOC.SelPenerimaanList"
        :dbparams="{
          StatusID: 1,
          Tahun: tahun,
          Keyword: keyword,
        }"
        height="calc(100vh - 160px)"
        @itemClick="RowClicked"
      >
        <template v-slot="{ row }">
          <div>
            <div style="font-weight:bold;">{{ row.NoSPM }}</div>
            <div style="color:gray;">
              {{ row.Keterangan | plain }}
            </div>
          </div>
        </template>
      </List>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    kabupaten: { val: null, txt: null },
    selectedArea: {},
    searchMode: false,
    keywordTxt: '',
    keyword: '',
    searchTo: 0,
    tahun: localStorage.getItem('tahun'),
  }),
  props: {
    value: Object,
  },
  watch: {
    searchMode(val) {
      if (!val) this.keywordTxt = ''
    },
    keywordTxt(val) {
      clearTimeout(this.searchTo)
      this.searchTo = setTimeout(() => {
        this.keyword = val
      }, 500)
    },
  },
  methods: {
    RowClicked(item) {
      // console.log(item)
      if (!item) return
      this.$emit('update:value', item)
    },
    filterArea(item) {
      return item.AreaName.match(new RegExp(this.keyword, 'i'))
    },
  },
}
</script>
<style lang="scss">
.sidebar-validasi {
  background: white;
  .ui-list {
    .--item {
      border-bottom: 1px solid #ddd;
      padding: 5px 8px;
      font-size: 12px;
      .ordr-1 {
        font-weight: bold;
        .status {
          display: none;
        }
      }
      .ordr-2 {
        padding-left: 10px;
        display: flex;
        & > div {
          flex: 1;
        }
        .status {
          justify-content: flex-end;
          display: flex;

          .badge {
            padding-right: 9px;
            padding-left: 9px;
            border-radius: 9px;
          }

          .s-jml {
            background-color: #f3f3f3;
          }
        }
      }
    }
  }
}
</style>
